import { render, staticRenderFns } from "./CreditTerm.vue?vue&type=template&id=e23bff5e&scoped=true&"
import script from "./CreditTerm.vue?vue&type=script&lang=js&"
export * from "./CreditTerm.vue?vue&type=script&lang=js&"
import style0 from "./CreditTerm.vue?vue&type=style&index=0&id=e23bff5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23bff5e",
  null
  
)

export default component.exports